export default __webpack_public_path__ + "static/neil-bitmoji-e6b2dadb168d47210dcbe45a3c9b2da2.png";